module.exports = __webpack_public_path__ + "static/Pollinators Menu-584f360f48ed239262282468576fbfe3.jpg";